import match from '@/common/match';
const commonVersionIdentifier = /version\/(\d+(\.?_?\d+)+)/i;
const browsersList = [
    /* Googlebot */
    {
        test: [/googlebot/i],
        describe(ua) {
            const browser = {
                name: 'Googlebot',
                version: '',
            };
            const version = match.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, ua) ||
                match.getFirstMatch(commonVersionIdentifier, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    /* Opera < 13.0 */
    {
        test: [/opera/i],
        describe(ua) {
            const browser = {
                name: 'Opera',
                version: '',
            };
            const version = match.getFirstMatch(commonVersionIdentifier, ua) ||
                match.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    /* Opera > 13.0 */
    {
        test: [/opr\/|opios/i],
        describe(ua) {
            const browser = {
                name: 'Opera',
                version: '',
            };
            const version = match.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, ua) ||
                match.getFirstMatch(commonVersionIdentifier, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/SamsungBrowser/i],
        describe(ua) {
            const browser = {
                name: 'Samsung Internet for Android',
                version: '',
            };
            const version = match.getFirstMatch(commonVersionIdentifier, ua) ||
                match.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/Whale/i],
        describe(ua) {
            const browser = {
                name: 'NAVER Whale Browser',
                version: '',
            };
            const version = match.getFirstMatch(commonVersionIdentifier, ua) ||
                match.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/MZBrowser/i],
        describe(ua) {
            const browser = {
                name: 'MZ Browser',
                version: '',
            };
            const version = match.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, ua) ||
                match.getFirstMatch(commonVersionIdentifier, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/focus/i],
        describe(ua) {
            const browser = {
                name: 'Focus',
                version: '',
            };
            const version = match.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, ua) ||
                match.getFirstMatch(commonVersionIdentifier, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/swing/i],
        describe(ua) {
            const browser = {
                name: 'Swing',
                version: '',
            };
            const version = match.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, ua) ||
                match.getFirstMatch(commonVersionIdentifier, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/coast/i],
        describe(ua) {
            const browser = {
                name: 'Opera Coast',
                version: '',
            };
            const version = match.getFirstMatch(commonVersionIdentifier, ua) ||
                match.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/opt\/\d+(?:.?_?\d+)+/i],
        describe(ua) {
            const browser = {
                name: 'Opera Touch',
                version: '',
            };
            const version = match.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, ua) ||
                match.getFirstMatch(commonVersionIdentifier, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/yabrowser/i],
        describe(ua) {
            const browser = {
                name: 'Yandex Browser',
                version: '',
            };
            const version = match.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, ua) ||
                match.getFirstMatch(commonVersionIdentifier, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/ucbrowser/i],
        describe(ua) {
            const browser = {
                name: 'UC Browser',
                version: '',
            };
            const version = match.getFirstMatch(commonVersionIdentifier, ua) ||
                match.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/Maxthon|mxios/i],
        describe(ua) {
            const browser = {
                name: 'Maxthon',
                version: '',
            };
            const version = match.getFirstMatch(commonVersionIdentifier, ua) ||
                match.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/epiphany/i],
        describe(ua) {
            const browser = {
                name: 'Epiphany',
                version: '',
            };
            const version = match.getFirstMatch(commonVersionIdentifier, ua) ||
                match.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/puffin/i],
        describe(ua) {
            const browser = {
                name: 'Puffin',
                version: '',
            };
            const version = match.getFirstMatch(commonVersionIdentifier, ua) ||
                match.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/sleipnir/i],
        describe(ua) {
            const browser = {
                name: 'Sleipnir',
                version: '',
            };
            const version = match.getFirstMatch(commonVersionIdentifier, ua) ||
                match.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/k-meleon/i],
        describe(ua) {
            const browser = {
                name: 'K-Meleon',
                version: '',
            };
            const version = match.getFirstMatch(commonVersionIdentifier, ua) ||
                match.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/micromessenger/i],
        describe(ua) {
            const browser = {
                name: 'WeChat',
                version: '',
            };
            const version = match.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, ua) ||
                match.getFirstMatch(commonVersionIdentifier, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/qqbrowser/i],
        describe(ua) {
            const browser = {
                name: /qqbrowserlite/i.test(ua) ? 'QQ Browser Lite' : 'QQ Browser',
                version: '',
            };
            const version = match.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, ua) || match.getFirstMatch(commonVersionIdentifier, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/msie|trident/i],
        describe(ua) {
            const browser = {
                name: 'Internet Explorer',
                version: '',
            };
            const version = match.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/\sedg\//i],
        describe(ua) {
            const browser = {
                name: 'Microsoft Edge',
                version: '',
            };
            const version = match.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/edg([ea]|ios)/i],
        describe(ua) {
            const browser = {
                name: 'Microsoft Edge',
                version: '',
            };
            const version = match.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/vivaldi/i],
        describe(ua) {
            const browser = {
                name: 'Vivaldi',
                version: '',
            };
            const version = match.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/seamonkey/i],
        describe(ua) {
            const browser = {
                name: 'SeaMonkey',
                version: '',
            };
            const version = match.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/sailfish/i],
        describe(ua) {
            const browser = {
                name: 'Sailfish',
                version: '',
            };
            const version = match.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/silk/i],
        describe(ua) {
            const browser = {
                name: 'Amazon Silk',
                version: '',
            };
            const version = match.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/phantom/i],
        describe(ua) {
            const browser = {
                name: 'PhantomJS',
                version: '',
            };
            const version = match.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/slimerjs/i],
        describe(ua) {
            const browser = {
                name: 'SlimerJS',
                version: '',
            };
            const version = match.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
        describe(ua) {
            const browser = {
                name: 'BlackBerry',
                version: '',
            };
            const version = match.getFirstMatch(commonVersionIdentifier, ua) ||
                match.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/(web|hpw)[o0]s/i],
        describe(ua) {
            const browser = {
                name: 'WebOS Browser',
                version: '',
            };
            const version = match.getFirstMatch(commonVersionIdentifier, ua) ||
                match.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/bada/i],
        describe(ua) {
            const browser = {
                name: 'Bada',
                version: '',
            };
            const version = match.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/tizen/i],
        describe(ua) {
            const browser = {
                name: 'Tizen',
                version: '',
            };
            const version = match.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, ua) ||
                match.getFirstMatch(commonVersionIdentifier, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/qupzilla/i],
        describe(ua) {
            const browser = {
                name: 'QupZilla',
                version: '',
            };
            const version = match.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, ua) ||
                match.getFirstMatch(commonVersionIdentifier, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/firefox|iceweasel|fxios/i],
        describe(ua) {
            const browser = {
                name: 'Firefox',
                version: '',
            };
            const version = match.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/electron/i],
        describe(ua) {
            const browser = {
                name: 'Electron',
                version: '',
            };
            const version = match.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/MiuiBrowser/i],
        describe(ua) {
            const browser = {
                name: 'Miui',
                version: '',
            };
            const version = match.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/chromium/i],
        describe(ua) {
            const browser = {
                name: 'Chromium',
                version: '',
            };
            const version = match.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, ua) ||
                match.getFirstMatch(commonVersionIdentifier, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/chrome|crios|crmo/i],
        describe(ua) {
            const browser = {
                name: 'Chrome',
                version: '',
            };
            const version = match.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: [/GSA/i],
        describe(ua) {
            const browser = {
                name: 'Google Search',
                version: '',
            };
            const version = match.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    /* Android Browser */
    {
        test(parser) {
            const notLikeAndroid = !parser.test(/like android/i);
            const butAndroid = parser.test(/android/i);
            return notLikeAndroid && butAndroid;
        },
        describe(ua) {
            const browser = {
                name: 'Android Browser',
                version: '',
            };
            const version = match.getFirstMatch(commonVersionIdentifier, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    /* PlayStation 4 */
    {
        test: [/playstation 4/i],
        describe(ua) {
            const browser = {
                name: 'PlayStation 4',
                version: '',
            };
            const version = match.getFirstMatch(commonVersionIdentifier, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    /* Safari */
    {
        test: [/safari|applewebkit/i],
        describe(ua) {
            const browser = {
                name: 'Safari',
                version: '',
            };
            const version = match.getFirstMatch(commonVersionIdentifier, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    /* Something else */
    {
        test: [/.*/i],
        describe(ua) {
            /* Here we try to make sure that there are explicit details about the device
             * in order to decide what regexp exactly we want to apply
             * (as there is a specific decision based on that conclusion)
             */
            const regexpWithoutDeviceSpec = /^(.*)\/(.*) /;
            const regexpWithDeviceSpec = /^(.*)\/(.*)[ \t]\((.*)/;
            const hasDeviceSpec = ua.search('\\(') !== -1;
            const regexp = hasDeviceSpec
                ? regexpWithDeviceSpec
                : regexpWithoutDeviceSpec;
            return {
                name: match.getFirstMatch(regexp, ua),
                version: match.getSecondMatch(regexp, ua),
            };
        },
    },
];
export default browsersList;
